import React from "react";

import "./mobile.css";

export default function SidebarOverlay(props) {
    const { onClick } = props;

    return <div className={"sidebar__overlay"} onClick={onClick} />;
}
